import React, { Component } from "react";
import styles from "./controlUsers.module.scss";
import { withUsers } from "../../../shared/containers/containerUsers";
import ControlUsersTable from "./ControlUsersTable";
import UserInformation from "./UserInfornation";
import CmsUserRolePermissions from "../../Cms/CmsUser/CmsUserRolePermissions";
import UserCreateTools from "../../Cms/CmsUsers/UserCreateTools";
import CmsUserPermissions from "../../Cms/CmsUser/CmsUserPermissions";

const PATHNAME = "/controls/users/";

class ControlUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabIndex: 0,
    };
  }

  componentDidMount() {
    const { onGetUsers, currentUser, onGetUser } = this.props;

    onGetUsers({ InCurrentCompany: true });

    if (window.location.pathname.includes(PATHNAME) && currentUser === null) {
      onGetUser(window.location.pathname.replace(PATHNAME, ""));
    }
  }

  componentWillUnmount() {
    const { onClearCurrentUser } = this.props;
    onClearCurrentUser();
  }

  onUserHandleClick(id) {
    const { onGetUser } = this.props;

    window.history.replaceState(null, null, `${PATHNAME}${id}`);
    onGetUser(id);
  }

  setTabIndex(tabIndex) {
    this.setState({ tabIndex });
  }

  getTabs() {
    const { tabIndex } = this.state;
    const titles = ["Привилегии роли пользователя", "Пользовательские Привилегии вне роли"];

    return titles.map((item, index) => {
      return (
        <div key={index} className={tabIndex === index ? styles.tabActive : styles.tab} onClick={this.setTabIndex.bind(this, index)}>
          {item}
        </div>
      );
    });
  }

  getTabView() {
    const { tabIndex } = this.state;

    switch (tabIndex) {
      case 0:
        return <CmsUserRolePermissions height={450} />;
      case 1:
        return <CmsUserPermissions height={450} />;
      case 2:
        return null;
      default:
        return null;
    }
  }

  render() {
    const { users, currentUser } = this.props;

    const isInfo = users.some((x) => {
      return currentUser !== null && x.id === currentUser.id;
    });

    return (
      <div className={styles.controlUsersPanelContainer}>
        <div className={styles.usersDataContainer}>
          <div className={styles.leftPanel}>
            <UserCreateTools />
            <ControlUsersTable users={users} onHandleClick={this.onUserHandleClick.bind(this)} />
          </div>
          {isInfo ? (
            <div className={styles.rigthPanel}>
              <UserInformation />
              <div className={styles.tabsContainer}>{this.getTabs()}</div>
              <div>{this.getTabView()}</div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default withUsers(ControlUsers);
